import { styles as _statusLogoStyles } from 'sletat-ui-components/lib/StatusLogo/themes/failed';

import {
    MORE_440_MEDIA_QUERY,
    MORE_620_MEDIA_QUERY,
    MORE_768_MEDIA_QUERY
} from '../../consts/adaptive';


export const styles = {
    container: {
        padding: [40, 12, 20],
        textAlign: 'center',
        color: '#313140'
    },
    title: {
        margin: 0,
        marginBottom: 8,
        padding: 0,
        fontSize: 16
    },
    text: {
        maxWidth: 296,
        margin: [0, 'auto'],
        fontSize: 12,
        lineHeight: '18px'
    },
    [MORE_440_MEDIA_QUERY]: {
        container: {},
        title: {},
        text: {
            maxWidth: 352
        }
    },
    [MORE_620_MEDIA_QUERY]: {
        container: {},
        title: {
            fontSize: 20,
            lineHeight: '24px'
        },
        text: {
            maxWidth: 496
        }
    },
    [MORE_768_MEDIA_QUERY]: {
        container: {},
        text: {
            maxWidth: 614,
            fontSize: 14,
            lineHeight: '20px'
        }
    }
};

export const statusLogoStyle = {
    ..._statusLogoStyles,
    container: {
        ..._statusLogoStyles.container,
        margin: [0, 'auto', 23],
        boxSizing: 'border-box',

        '&::after': {
            ..._statusLogoStyles.container['&::after'],
            boxShadow: [0, 0, 0, 15]
        }
    },
    [MORE_620_MEDIA_QUERY]: {
        container: {
            marginBottom: 20
        },
    },
    [MORE_768_MEDIA_QUERY]: {
        container: {
            marginBottom: 31
        },
    }
};


export type ComponentJSSClasses = JSSClasses<typeof styles>;
